export const SET_PLAYER_LIMITS_INFO = 'SET_LIMITS_INFO';
export const SET_PLAYER_FORCED_LIMITS_INFO = 'SET_PLAYER_FORCED_LIMITS_INFO';

export const SET_PLAYER_FORCED_DEPOSIT_LIMITS_INFO = 'SET_PLAYER_FORCED_DEPOSIT_LIMITS_INFO';
export const SET_DEPOSIT_LIMITS_CONFIG = 'SET_DEPOSIT_LIMITS_CONFIG';
export const SET_TIMEOUTS = 'SET_TIMEOUTS';
export const SET_RG_CONFIGURATION = 'SET_RG_CONFIGURATION';
export const SET_PLAYER_REALITY = 'SET_PLAYER_REALITY';
export const SET_PLAYER_SELF_EXCLUSION = 'SET_PLAYER_SELF_EXCLUSION';
export const SET_RESPONSIBLE_GAMING_TIMEOUTS = 'SET_RESPONSIBLE_GAMING_TIMEOUTS';
export const RESET_RESPONSIBLE_GAMING = 'RESET_RESPONSIBLE_GAMING';

export const resetResponsibleGaming = () => ({
    type: RESET_RESPONSIBLE_GAMING
});

export const setPlayerForcedLimitsInfo = limitsInfo => ({
    type: SET_PLAYER_FORCED_LIMITS_INFO,
    payload: limitsInfo
});

export const setPlayerLimitsInfo = limitsInfo => ({
    type: SET_PLAYER_LIMITS_INFO,
    payload: limitsInfo
});

export const setPlayerForcedDepositLimitsInfo = limitsInfo => ({
    type: SET_PLAYER_FORCED_DEPOSIT_LIMITS_INFO,
    payload: limitsInfo
});

export const setDepositLimitConfig = depositLimitConfig => ({
    type: SET_DEPOSIT_LIMITS_CONFIG,
    payload: depositLimitConfig
});

export const setTimeouts = timeouts => ({
    type: SET_TIMEOUTS,
    payload: timeouts
});

export const setRgConfiguration = rgConfiguration => ({
    type: SET_RG_CONFIGURATION,
    payload: rgConfiguration
});

export const setPlayerReality = playerReality => ({
    type: SET_PLAYER_REALITY,
    payload: playerReality
});

export const setPlayerSelfExclusion = playerSelfExclusion => ({
    type: SET_PLAYER_SELF_EXCLUSION,
    payload: playerSelfExclusion
});

export const setResponsibleGamingTimeouts = responsibleGamingTimeouts => ({
    type: SET_RESPONSIBLE_GAMING_TIMEOUTS,
    payload: responsibleGamingTimeouts
});
